import React from 'react';

export const ProductDetail: React.FC = () => {
  return (
    <div>
      <h1>Build Your Own</h1>
    </div>
  );
};